import { memo } from "react";
import type { ToolCallNodeProps } from "../../ToolCallIndicator.types";
import ToolCallIndicatorNodeCompleted from "./components/ToolCallIndicatorNodeCompleted/ToolCallIndicatorNodeCompleted";
import ToolCallIndicatorNodePending from "./components/ToolCallIndicatorNodePending/ToolCallIndicatorNodePending";

function ToolCallIndicatorNode(props: ToolCallNodeProps) {
  return props.status === "pending" ? (
    <ToolCallIndicatorNodePending {...props} />
  ) : (
    <ToolCallIndicatorNodeCompleted {...props} />
  );
}

// Custom equality: `groupDisplayContent` allocates fresh prop objects on every
// streaming tick (so default shallow-compare always invalidates the memo).
// We compare on the fields that actually drive rendering. `body` is the
// expensive one — its identity matters because <CodeSnippet> below tokenizes
// it via Prism, which is the dominant cost during streaming.
function arePropsEqual(prev: ToolCallNodeProps, next: ToolCallNodeProps): boolean {
  if (prev.status !== next.status) return false;
  if (prev.toolCallId !== next.toolCallId) return false;
  if (prev.name !== next.name) return false;
  if (prev.hasInputParseError !== next.hasInputParseError) return false;
  // input may be mutated in place upstream (stream layer), so reference compare
  // catches the typical case; deep compare would be too expensive per tick.
  if (prev.input !== next.input) return false;
  if (prev.status === "completed" && next.status === "completed") {
    if (prev.body !== next.body) return false;
    if (prev.isError !== next.isError) return false;
  }
  return true;
}

export default memo(ToolCallIndicatorNode, arePropsEqual);
